var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-home"},[(!_vm.headerHidden)?_c('CommonHeader'):_vm._e(),_c('router-view'),(!_vm.hiddenBlock)?_c('Footer'):_vm._e(),(!_vm.hiddenBlock)?_c('FooterBanner'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }